import { useEffect, useState } from "react";
import { SidebarProvider } from "src/components/ui/sidebar";
import ChatSidebar from "./_components/chat-sidebar";
import ChatInterface from "./_components/chat-interface";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import { toast } from "sonner";

export default function ChatPage() {
  const [selectedUser, setSelectedUser] = useState(null);

  const [loadingConversation, setLoadingConversation] = useState(true);
  const [conversation, setConversation] = useState([]);

  const getAllConversation = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/conversations`);
      const users = data.data.flatMap((item) => item.users);
      setConversation(users);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingConversation(false);
    }
  };

  const [loadingMessages, setLoadingMessages] = useState(true);
  const [messages, setMessages] = useState([]);
  const getAllMessages = async () => {
    try {
      const { data } = await axios.get(
        `${BaseUrlApi}/messages/${selectedUser?.pivot?.conversation_id}`
      );
      setMessages(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingMessages(false);
    }
  };

  useEffect(() => {
    getAllConversation();
  }, []);

  console.log(selectedUser);

  useEffect(() => {
    if (selectedUser) getAllMessages();
  }, [selectedUser]);

  return (
    <main className="flex">
      <SidebarProvider>
        <ChatSidebar
          onSelectUser={setSelectedUser}
          selectedUser={selectedUser}
          conversation={conversation}
          loadingConversation={loadingConversation}
        />
        <div className="flex-1 ps-4">
          <div className="w-full h-[calc(100vh-6rem)] shadow-sm rounded-xl overflow-hidden border sticky top-0 bottom-0">
            <ChatInterface
              selectedUser={selectedUser}
              conversation={conversation}
              messages={messages}
              setMessages={setMessages}
              loadingMessages={loadingMessages}
            />
          </div>
        </div>
      </SidebarProvider>
    </main>
  );
}
